import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  deleteCategory,
  editCategory,
  fetchCategoryList,
  openGlobalPopup,
  closeGlobalPopup
} from '../../redux/action';
import GlobalPopup from "../../component/Popup/GlobalPopup.js";
import MobileFilterCard from "../common/MobileFilterCard";
import ConfirmBox from "../Popup/ConfirmBox";
import CategoryCard from "./CategoryCard";
import {Layers} from "lucide-react";
import MapCategoryAddonForm from "./MapCategoryAddonForm";
import { useTranslation } from "react-i18next";
import EmptyScreen from "../common/EmptyScreen";

import "./CategoryMobileList.css"; // your separate CSS

function CategoryMobileList({ onEdit }) {
  const { t } = useTranslation();
  const [deleteCategories, setIsDeleteCategories] = useState('');
  const categoriesObj = useSelector((state) => state.admin?.categories) || [];
  const [selectedCategoryForAddon, setSelectedCategoryForAddon] = useState(null);
  const categories = Array.isArray(categoriesObj)
    ? categoriesObj
    : Object.values(categoriesObj);

  const dispatch = useDispatch();
  const [search, setSearch] = useState("");

  useEffect(() => {
    dispatch(fetchCategoryList());
  }, [dispatch]);

  const filteredcategories = categories.filter((category) =>
    category.categoryName.toLowerCase().includes(search.toLowerCase())
  );

  const handleDelete = (categoryId) => {
    setIsDeleteCategories(categoryId);
    dispatch(openGlobalPopup("confirm-box"));
  };

  const handleEdit = (cat) => {
    dispatch(editCategory(cat));
    onEdit();
  };

  const handleOpenAddons = (cat) => {
    setSelectedCategoryForAddon(cat);
    dispatch(openGlobalPopup("map-category-addon"));
  };

  return (
    <div className="category-container">
      <MobileFilterCard
        label={t("Search categories")}
        hint={t("Find a menu category by name.")}
        placeholder={t("Search category by name...")}
        search={search}
        setSearch={setSearch}
        countText={`${filteredcategories.length} ${t("categories")}${search.trim() ? ` ${t("found")}` : ""}`}
      />

      {filteredcategories.length === 0 ? (
        <EmptyScreen
          compact
          message={categories.length ? "No matching categories found." : "No categories yet."}
          subText={categories.length ? "Clear the search to view all categories." : "Add a category to begin organising the menu."}
          actionLabel={categories.length && search ? "Clear search" : undefined}
          onAction={categories.length && search ? () => setSearch("") : undefined}
        />
      ) : (
        <ul className="card-list">
          {filteredcategories.map((cat) => (
            <CategoryCard
              key={cat.categoryId}
              cat={cat}
              categories={categories}
              onEdit={handleEdit}
              onDelete={handleDelete}
              onOpenAddons={handleOpenAddons}
            />
          ))}
        </ul>
      )}

      <ConfirmBox
        variant="delete"
        title={"Are you sure you want to delete this category?"}
        onConfirm={() => {
          dispatch(deleteCategory(deleteCategories));
        }}
        onCancel={() => {
          setIsDeleteCategories('');
        }}
      />

      <GlobalPopup
        popupKey="map-category-addon"
        title={`Map Add-ons: ${selectedCategoryForAddon?.categoryName || ""}`}
        onClose={() => {
          setSelectedCategoryForAddon(null);
          dispatch(closeGlobalPopup());
        }}
      >
        <MapCategoryAddonForm category={selectedCategoryForAddon} />
      </GlobalPopup>

    </div>
  );
}

export default CategoryMobileList;
